var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notifications.length > 0
    ? _c(
        "div",
        { staticClass: "alert-wrap" },
        [
          _c(
            "transition-group",
            { attrs: { name: _vm.transition, appear: true, tag: "div" } },
            _vm._l(_vm.notifications, function(item, index) {
              return _c(
                "div",
                {
                  key: index + 0,
                  class: item.typeObject,
                  attrs: { role: "alert" }
                },
                [
                  _vm.displayIcons
                    ? _c("span", {
                        staticClass: "flash-icon",
                        class: item.iconObject
                      })
                    : _vm._e(),
                  _c("span", { domProps: { innerHTML: _vm._s(item.message) } }),
                  _vm._v(" "),
                  item.isImportant
                    ? _c(
                        "button",
                        {
                          staticClass: "flash__close-button",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "alertClose"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hide(item)
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }